import { Button, Intent } from "@blueprintjs/core";
import { FGNumberInput, FGSelectInput, FieldGroup, FieldSet, showError } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { BroodRequesReportDetailDto, FileDownload, RequestApi } from "../../api";
import { SmallFormGenerator } from "../../components";
import { useApiService, useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales";
import { b64toBlob } from "../../utils";
import { saveAs } from "file-saver";

export interface ITurnOverReportProps {}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export const TurnOverReport: React.FunctionComponent<ITurnOverReportProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(RequestApi);
  const [saving, setsaving] = React.useState(false);
  const [months, mLoading] = useReferential((a) => a.getMonths(), true, []);
  const getDoc = React.useCallback(
    async (d: any) => {
      try {
        setsaving(true);
        var file = await api.getTurnOverReport(d.month, d.year);
        if (file?.fileBytes) {
          var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
          saveAs(blob, file.fileName);
        }
        setsaving(false);
      } catch {
        showError(t(ETLCodes.Error));
        setsaving(false);
      }
    },
    [api, t]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      month: Yup.number().nullable().required(t(ETLCodes.Required)),
      year: Yup.number().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  return (
    <FieldSet title={t(ETLCodes.TurnOver)}>
      <SmallFormGenerator
        initialValues={BroodRequesReportDetailDto.fromJS({})}
        onSubmit={getDoc}
        editMode={true}
        showDeleteButton={false}
        validationSchema={FormSchema}
        hideButtons={true}
      >
        <FieldGroup>
          <FGSelectInput name="month" label={t(ETLCodes.Month)} items={months} loading={mLoading} />
          <FGNumberInput name="year" min={2000} label={t(ETLCodes.Year)} />
        </FieldGroup>
        <Container>
          <Button
            type={"submit"}
            text={t(ETLCodes.GenerateReport)}
            loading={saving}
            intent={Intent.PRIMARY}
            icon={<i className="far fa-file-excel" />}
          />
        </Container>
      </SmallFormGenerator>
    </FieldSet>
  );
};
